import React from "react"
import {useTheme} from "@mui/material"
import {Drawer} from "@next/drawer"
import BurgerSecondaryNav from "../../../BurgerSecondaryNav"
import {DrawerBackdrop, DrawerPaper} from "./components"
import BurgerPrimaryNav from "../../../BurgerPrimaryNav"
import useMediaQuery from "../../../../hooks/useMediaQuery"

export interface BurgerMenuDrawerProps {
    isBurgerVisible: boolean
    handleState: () => void
    mobileHeight: number
}

/*
 * Title: Passing inline styles
 * Problem: we do not want to use !important but we want a modal and a modal is expected to cover the entire screen
 * in this case however, material UI probably assumes you'll have the entire screen covered and uses inline styles
 * to define this behaviour. But here the modal as it is the case of next, partially exposes the header area hence it
 * does not fully cover the entire screen.
 * Solution: for now we have to use inline styles.
 * Alternative Solution: use !important tags on styled components.
 * Refs:
 *    https://github.com/mui-org/material-ui/issues/16441
 *    https://github.com/mui-org/material-ui/issues/16442
 */

const DrawerBackdropComponent = props => <DrawerBackdrop data-testid="header-burger-menu-backdrop" {...props} />

export const BurgerMenuDrawer = ({isBurgerVisible, handleState, mobileHeight}: BurgerMenuDrawerProps) => {
    const theme = useTheme()
    const modalProps = {
        style: {inset: `var(--next-header-height, 5rem) 0 0 0`},
        disablePortal: true,
        BackdropComponent: DrawerBackdropComponent,
        BackdropProps: {style: {top: `var(--next-header-height, 5rem)`}},
    }
    const showAsWideView = useMediaQuery(theme.breakpoints.up("lg"))
    return (
        <Drawer
            open={isBurgerVisible}
            anchor="left"
            testId="header-burger-menu"
            onClose={handleState}
            showCloseIcon={false}
            ModalProps={modalProps}
            CustomPaperProps={{
                component: DrawerPaper,
            }}
        >
            <BurgerPrimaryNav showAsWideView={showAsWideView} />
            <BurgerSecondaryNav showAsWideView={showAsWideView} />
        </Drawer>
    )
}

export default BurgerMenuDrawer
